import React from 'react'

import { RecipeTile as PureRecipeTile } from '@features/recipe-tile'
import { RecipeTileProps } from '@features/recipe-tile/src/components/RecipeTile'

import { useBasketRecipes } from 'hooks/basket/useBasketRecipes'
import { useIsRecipeInStock } from 'hooks/menu-recipes/useIsRecipeInStock'
import { useRecipeOptions } from 'routes/Menu/domains/menu'

export const RecipeTile = (
  props: Omit<RecipeTileProps, 'alternativeOptions' | 'isOutOfStock' | 'isInBasket'>,
) => {
  const { recipe, currentCollectionId } = props
  const alternativeOptions = useRecipeOptions(currentCollectionId, recipe)
  const isOutOfStock = !useIsRecipeInStock(recipe.id)

  const { basketHasRecipe } = useBasketRecipes()

  return (
    <PureRecipeTile
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      alternativeOptions={alternativeOptions}
      isOutOfStock={isOutOfStock}
      isInBasket={basketHasRecipe(recipe.coreId)}
    />
  )
}
